export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Latin2-1b7e07ae5a922f10d82d2e559af2d7c0.woff";